import { render } from "./Multicolumn.vue?vue&type=template&id=5b1f3060"
import script from "./Multicolumn.vue?vue&type=script&lang=js"
export * from "./Multicolumn.vue?vue&type=script&lang=js"

import "./Multicolumn.vue?vue&type=style&index=0&id=5b1f3060&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/Multicolumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b1f3060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b1f3060', __exports__)) {
    api.reload('5b1f3060', __exports__)
  }
  
  module.hot.accept("./Multicolumn.vue?vue&type=template&id=5b1f3060", () => {
    api.rerender('5b1f3060', render)
  })

}


export default __exports__